import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { SharedService } from '../_service/shared.service';
import { TransactionService } from '../_service/transaction.service';
import * as XLSX from 'xlsx';
declare var $: any;
@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.css']
})
export class TransactionComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('dateRangeStart', { static: false }) dateRangeStart: ElementRef;
  @ViewChild('dateRangeEnd', { static: false }) dateRangeEnd: ElementRef;
  @ViewChild('PaymentReceivedDateStart', { static: false }) PaymentReceivedDateStart: ElementRef;
  @ViewChild('PaymentReceivedDateEnd', { static: false }) PaymentReceivedDateEnd: ElementRef;
  @ViewChild('csvUpload', {static: false}) csvUpload: ElementRef;

  perpage: number = 25; transactionList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true;
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; start_date: string = ''; end_date: string = '';
  search_data = ''; payment_type = ''; status_search = ''; alluser = []; alluser_copy = []; userSearch = ''; start_date_payment_received: string = ''; end_date_payment_received: string = '';s3url:string='';submitted:boolean=false;
  constructor(private sharedapi: SharedService, private transactionapi: TransactionService) { }

  ngOnInit(): void {
    this.getAllActiveUser();
    this.s3url = localStorage.getItem('s3url');
  }

  ngAfterViewInit() {
    this.loadTransactionList(0, this.perpage);
  }

  async loadTransactionList(pageIndex, perpage) {
    this.transactionList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search_data + '&payment_type=' + this.payment_type + '&status_search=' + this.status_search + '&userSearch=' + this.userSearch +
      '&payment_link_sent_date=' + this.start_date + '-' + this.end_date + '&payment_received_date=' + this.start_date_payment_received + '-' + this.end_date_payment_received;
    this.loading = true; this.loaded = false;
    await this.transactionapi.getTransactionList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.total);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.transactionList = data.data;
      } else {
        this.transactionList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  async getAllActiveUser() {
    await this.transactionapi.getUser().subscribe((data: any) => {
      if (data.status) {
        this.alluser = data.data;
        this.alluser_copy = this.alluser;
      } else {
        this.alluser = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'user') {
      this.alluser = this.sharedapi.searchData(searchtText, this.alluser_copy, "name");
    }
  }

  setSearchValue(type) {
    if (type == 'user') {
      $("#alluserSearch").val('');
      $("#alluserSearch").focus();
      this.alluser = this.alluser_copy;
    }
  }


  dateRangeChangePaymentLink(date1, date2) {
    if (date2.value) {
      this.start_date = date1.value;
      this.end_date = date2.value;
    }
  }
  clearDatePaymentLink() {
    this.dateRangeStart.nativeElement.value = "";
    this.dateRangeEnd.nativeElement.value = "";
    this.start_date = '';
    this.end_date = '';
  }

  dateRangeChangePaymentReceived(date1, date2) {
    if (date2.value) {
      this.start_date_payment_received = date1.value;
      this.end_date_payment_received = date2.value;
    }
  }

  clearDatePaymentReceived() {
    this.PaymentReceivedDateStart.nativeElement.value = "";
    this.PaymentReceivedDateEnd.nativeElement.value = "";
    this.start_date_payment_received = '';
    this.end_date_payment_received = '';
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadTransactionList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadTransactionList(event.pageIndex, event.pageSize);
  }

  resetFilters() {
    this.clearDatePaymentLink();
    this.clearDatePaymentReceived();
    this.search_data = ''; this.payment_type = ''; this.status_search = ''; this.userSearch = '';
    this.loadTransactionList(0, 25);
  }
  //-----------------------------Export List-----------------------------//
  exportTransactionList() {
    if (this.transactionList.length > 0) {
      let data = [];
      let titles = ['Glamyo Patient ID', 'Name', 'Mobile', 'Payment Type', 'Plan Type', 'Amount', 'Order ID', 'Payment ID', 'Payment Link Sent Date', 'Payment Received Date', 'Payment Link Sent By', 'Status'];
      data.push(titles);


      for (let key in this.transactionList) {
        let extData = [this.transactionList[key].glamyo_patient_id, this.transactionList[key].lead_name,
        this.transactionList[key].lead_mobile, this.transactionList[key].payment_type,
        this.transactionList[key].plan_type, this.transactionList[key].amount,
        this.transactionList[key].payment_link_id, this.transactionList[key].payment_id,
        this.transactionList[key].payment_link_send_date, this.transactionList[key].payment_received_date,
        this.transactionList[key].created_by, this.transactionList[key].status];
        data.push(extData)
      }
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      XLSX.writeFile(wb, 'Transactionlist' + utc + '.xlsx');
    } else {
      this.sharedapi.presentToast('No Transaction Data found!');
    }
  }

  hideModal()
    {
        $('#myModal').modal('hide');
    }

  showModal()
    {
        $('#myModal').modal();
    }

    async selectFile(event)
    {
        this.submitted = true;
        let file = event.target.files.item(0);
        const formData = new FormData();
        formData.append('file', file);
        this.transactionapi.uploadupTransactionloadcsv(formData)
        .subscribe((data:any) => {
            this.submitted = false;
            this.csvUpload.nativeElement.value = "";
            if(data.status)
            {
                this.hideModal();
                this.sharedapi.presentToast(data.msg);
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }

}
